exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".training-more-info-btn{background:#bce3f4;color:#111!important;font-weight:600;border:0;padding:6px 16px;border-radius:10px;text-decoration:none!important;display:inline-block}.training-more-info-btn:focus,.training-more-info-btn:hover{background:#a9d8ee;color:#111!important;text-decoration:none!important}button.training-more-info-btn,input.training-more-info-btn{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/training/training.shared.css
// module id = 1247
// module chunks = 0